import React from "react";
import { labels } from "../../../../localization/labels";
import OrganisationMaster from "./OrganisationMaster";

const OrganisationsAdministration = props => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <OrganisationMaster
          messageHandler={props.messageHandler}
          breadcrumbsHandler={props.breadcrumbsHandler}
          history={props.history}
          tableLabel={labels.organisations}
          showTableHeader
        />
      </div>
    </div>
  );
};

export default OrganisationsAdministration;
